import { FooterSNSItemTypes } from '../../../types/GlobalTypes';

// Footer SNS 링크 (locale별). 거의 안 바뀌는 데이터를 Weegloo CMS 런타임 fetch 하다
// 401/503 → 페이지 전체가 죽던 이슈(Sentry WEB-APP-1S5)로 상수 고정. 변경 시 이 파일만 수정.
const CDN = 'https://cdn-static.zep.us/static/images/light/layout';

const INSTAGRAM: FooterSNSItemTypes = {
  hidden: false,
  linkUrl: 'https://www.instagram.com/zep.us_official/',
  imageUrl: `${CDN}/icon_instagram.png`,
  imageAlt: 'instagram icon',
};

const X: FooterSNSItemTypes = {
  hidden: false,
  linkUrl: 'https://twitter.com/ZEP_global',
  imageUrl: `${CDN}/icon_x.png`,
  imageAlt: 'twitter icon',
};

const YOUTUBE: FooterSNSItemTypes = {
  hidden: false,
  linkUrl: 'https://www.youtube.com/watch?v=MMnn78lBs9Y',
  imageUrl: `${CDN}/icon_youtube.png`,
  imageAlt: 'youtube icon',
};

const NAVER_BLOG: FooterSNSItemTypes = {
  hidden: false,
  linkUrl: 'https://blog.naver.com/zep_business',
  imageUrl: `${CDN}/icon_naverBlog.png`,
  imageAlt: 'naver icon',
};

const AMEBA: FooterSNSItemTypes = {
  hidden: false,
  linkUrl: 'https://www.ameba.jp/profile/general/zep-japan/',
  imageUrl: `${CDN}/icon_ameba.png`,
  imageAlt: 'ameba icon',
};

const DISCORD: FooterSNSItemTypes = {
  hidden: false,
  linkUrl: 'https://discord.com/invite/tHgxcxDbe2',
  imageUrl: `${CDN}/icon_discord.png`,
  imageAlt: 'discord icon',
};

export const FOOTER_SNS_LIST: Record<string, FooterSNSItemTypes[]> = {
  ko: [INSTAGRAM, X, YOUTUBE, NAVER_BLOG],
  ja: [X, YOUTUBE, AMEBA],
  default: [INSTAGRAM, X, YOUTUBE, DISCORD],
};
